//@ts-ignore
import { SplitBreakdown } from "@tuteria/shared-lib/src/_new_/features/request-flow/admin/SplitBreakdown";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";

export function unMountDisplaySplitBreakdown(id: string) {
  ReactDOM.unmountComponentAtNode(document.getElementById(id));
}

type Props = {
  getRequestData: () => any;
  handleClosingModal: () => Promise<void>;
};

const Component = ({ handleClosingModal, getRequestData }: Props) => {
  return (
    <SplitBreakdown
      getRequestData={getRequestData}
      handleClosingModal={handleClosingModal}
    />
  );
};

type Payload = {
  slug: string;
};

export function displaySplitBreakdown(
  payload: Payload,
  id: string,
  urls: {},
  callback: (...args: any[]) => void
) {
  const {} = payload;

  function onClose() {
    unMountDisplaySplitBreakdown(id);
  }

  async function getRequestData() {
    const response = await fetch(
      `/new-flow/update-home-tutoring-request/${payload.slug}?as_parent=true`
    );
    try {
      const data = await response.json();
      if (response.status < 400) {
        return data.data;
      }
      throw new Error(data.errors);
    } catch (e) {
      throw e;
    }
  }

  ReactDOM.render(
    <ThemeProvider>
      <Component
        {...{
          handleClosingModal: onClose,
          getRequestData,
        }}
      />
    </ThemeProvider>,
    document.getElementById(id)
  );
}
